import { withErrorHandling } from '@selfserve/react-hocs';
import { CreateAccount } from '../utils/create-account';
import {TFunction} from "i18next";
import * as Yup from "yup";

export const CreateAccountBase = withErrorHandling(({ openErrorModal }) => {

  const validationSchema = (t: TFunction, isUserExist?: boolean) =>
    Yup.object().shape({
      firstName: Yup.mixed().required(t('common.validations.firstname-required')),
      lastName: Yup.mixed().required(t('common.validations.lastname-required')),
      company: Yup.mixed().required(t('common.validations.company-required')),
      jobTitle: Yup.mixed().required(t('common.validations.job-title-required')),
      ...(!isUserExist && {
        password: Yup.mixed().required(t('common.validations.password-required')),
        passwordErrors: Yup.object().when('password', (password) => {
          return Yup.object().shape({
            minLengthErr: Yup.mixed().test({
              test: () => !!(password && password.length >= 8),
            }),
            oneNumberErr: Yup.mixed().test({
              test: () => !!(password && /\d/.test(`${password}`)),
            }),
            upperCaseErr: Yup.mixed().test({
              test: () => !!(password && `${password}`.match('.*[A-Z].*')),
            }),
            lowerCaseErr: Yup.mixed().test({
              test: () => !!(password && `${password}`.match('.*[a-z].*')),
            }),
          });
        })
      }),
    });

  return (
    <CreateAccount isFullForm={false} validationSchema={validationSchema}></CreateAccount>
  );
});
